import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { StmxCommonLoaderService } from 'ngx-exdr-stmx-common';
import { CustomDomainService } from './shared/services/custom-domain.service';
import { filter, map, mergeMap } from 'rxjs';
import { SharedService } from './shared/services/shared.service';
import { LoaderComponent } from 'ngx-exdr-stmx-common/components/loader';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    TranslateModule,
    LoaderComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  private previousUrl: string;
  private currentUrl: string;
  faviconUrl: WritableSignal<string> = signal('');
  constructor(
    customDomainService: CustomDomainService,
    stmxCommonLoaderService: StmxCommonLoaderService,
    private _router: Router,
    private _route: ActivatedRoute,
    private sharedService: SharedService
  ) {
    // get group id if group id is not present or * then redirect to legacy website to choose group page
    stmxCommonLoaderService.showSpinner();
    customDomainService.getGroupId().subscribe(groupId => {
      stmxCommonLoaderService.hideSpinner();
      console.log(groupId);
      stmxCommonLoaderService.showSpinner();
      customDomainService.getGroupInformationAndCheckRedirectionToLogin(groupId).subscribe(groupInfo => {
        stmxCommonLoaderService.hideSpinner();
        if(groupInfo?.Profile?.ProfileImageUrl){
          this.faviconUrl.set(groupInfo?.Profile?.ProfileImageUrl);
        }
        // console.log(groupInfo);
      });

      stmxCommonLoaderService.showSpinner();
      customDomainService.getAddonAndInitializeTheme(groupId).subscribe(addons => {
        stmxCommonLoaderService.hideSpinner();
        // console.log(addons);
      });
    });

    this._router.events.subscribe((routerEvent: Event) => {
      // console.log('router event 1')
      if (routerEvent instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        if (routerEvent.url != routerEvent.urlAfterRedirects) {
          this.currentUrl = routerEvent.urlAfterRedirects;
        } else {
          this.currentUrl = routerEvent.url;
        }        
      }
    })

    this._router.events.pipe(
      filter((event) => event instanceof NavigationEnd && this.currentUrl !== this.previousUrl),
      map(() => this._route),
      map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => {
        return route.data
      })
    )
      .subscribe((data) => {
        this.setBannerdata(data?.metaData);
        // if (data?.productDetail?.fullScreen) {
        //   this.stemexeDataProvider.setPageWidth('full');
        // } else {
        //   this.stemexeDataProvider.setPageWidth(data?.pageWidth || 'default');
        // }        
      });



  }


  async setBannerdata(data) {
    const resolvedValue = await data;    
    const urlFragments = this._router.url.split('/');
    const isCustomTab = this._route.snapshot.queryParams?.tabId
    if ((urlFragments.length == 2) || isCustomTab) {
      this.sharedService.bannerSubject.next(resolvedValue?.banner);
    } else {
      this.sharedService.bannerSubject.next(null);
    }
  }
}
